import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import actions from '../actions/white_list';
import rf from '../../requests/RequestFactory';

// saga effect
import {
  DELETE_ADDRESS, FETCH_ADDRESS, SAVE_ADDRESS, UPDATE_ADDRESS,
} from '../actions/white_list/action_types';
import utils from '../../common/utils';

function* fetchAddress(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('WhiteListRequest').fetchWhiteListAddress(params), action.params.data);
    yield put(actions.onFetchAddressActionSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onFetchAddressActionFailed(err));
  }
}

function* saveAddress(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('WhiteListRequest').addAddressToWhiteList(params), action.params.data);
    yield put(actions.onSaveAddressActionSucceed(data));
    yield utils.showNotification('Notification', 'Add white list address succeed');
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onSaveAddressActionFailed(err));
    yield utils.showNotification('Notification', 'Add white list address succeed');
  }
}

function* updateAddress(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('WhiteListRequest').updateWhiteListAddress(params), action.params.data);
    yield put(actions.onUpdateAddressActionSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onUpdateAddressActionFailed(err));
  }
}

function* deleteAddress(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('WhiteListRequest').deleteWhiteListAddress(params), action.params.data);
    yield put(actions.onDeleteAddressActionSucceed(data));
    yield utils.showNotification('Notification', 'Delete white list address succeed');
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.onDeleteAddressActionFailed(err));
    yield utils.showNotification('Notification', 'Delete white list address succeed');
  }
}

function* watchAllWhiteList() {
  yield takeLatest(FETCH_ADDRESS, fetchAddress);
  yield takeLatest(SAVE_ADDRESS, saveAddress);
  yield takeLatest(UPDATE_ADDRESS, updateAddress);
  yield takeLatest(DELETE_ADDRESS, deleteAddress);
}

export default function* rootSaga() {
  yield all([fork(watchAllWhiteList)]);
}
